/*eslint-disable*/
import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import SweetAlert from "react-bootstrap-sweetalert";
import { NavLink, useParams } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Pagination from "@material-ui/lab/Pagination";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Input from "@material-ui/core/Input";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";

// @material-ui/icons
import CloseIcon from "@material-ui/icons/Close";
import SaveIcon from "@material-ui/icons/Save";
import AssignmentIcon from "@material-ui/icons/Assignment";
import SearchIcon from "@material-ui/icons/Search";
import AlertIcon from "@material-ui/icons/AddAlert";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import DescriptionIcon from "@material-ui/icons/Description";
import DeleteIcon from "@material-ui/icons/Delete";
import PersonIcon from "@material-ui/icons/Person";
import PersonOutlineOutlinedIcon from "@material-ui/icons/PersonOutlineOutlined";
import DateRangeIcon from "@material-ui/icons/DateRange";
import DateRangeOutlinedIcon from "@material-ui/icons/DateRangeOutlined";
import EditIcon from "@material-ui/icons/Edit";
import AddIcon from "@material-ui/icons/AddCircle";
import Check from "@material-ui/icons/Check";
import ListAltIcon from "@material-ui/icons/ListAlt";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Table from "components/Table/Table.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";
import CustomTabs from "components/CustomTabs/CustomTabs.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import Accordion from "components/Accordion/Accordion.js";
import i18n from "components/Translation/Translate.js";
import { withNamespaces } from "react-i18next";
import { PostData } from "services/Request";
import * as Func from "services/Function";
import UploadImage from "./UploadImage";

import styles from "assets/jss/main-style.js";
import MemberWallet from "./MemberWallet";
import MemberTransfer from "./MemberTransfer";

/* ========== ZONE Variable ========== */
const useStyles = makeStyles(styles);

const initAttr = {
  code: "",
  id: "",
  name: "",
  company_name: "",
  company_id: "",
  tel: "",
  lineid: "",
  idcard: "",
  email: "",
  address: "",
  district: "",
  city: "",
  zipcode: "",
  promotion_code: "",
  type_code: "",
  province_code: "",
  image: ``,
  shipping: "Y",
  gen_receipt: "N",
  enable: "Y",
  credit_day: "",
};

const initFind = {
  search: "",
  order_by: "tb.code",
  order_sort: "desc",
  status: "ALL",
  page: 1,
  perPage: 10,
  pageTotal: 0,
};

const initField = {
  code: "",
  credit: "",
  remark: "",
};

/* ========== ZONE Function ========== */
function MemberType({ t }) {
  const mod = "member";
  const prefix = "attr";
  const classes = useStyles();

  const initHeader = [
    { code: "tb.code", name: `${prefix}.code`, order: "desc" },
    { code: "tb.filepic", name: `${mod}.image` },
    { code: "tb.id", name: `${mod}.id` },
    { code: "tb.name", name: `${mod}.name` },
    { code: "tb.company_name", name: `${mod}.company_name` },
    { code: "tb.type", name: `${mod}.type` },
    { code: "tb.promotion", name: `${mod}.promotion` },
    { code: "tb.balance", name: `Wallet` },
    { code: "tb.credit", name: "field.credit_limit" },
    { code: "tb.credit_day", name: "field.credit" },
    { code: "tb.gen_receipt", name: "field.vat_system" },
    { code: "tb.shipping", name: "field.notify_shipping" },
    { code: "tb.enable", name: `${prefix}.enable` },
  ];
  const alignValue = [0, 1, 2, 7, 8, 9, 10, 11, 12, 13];
  const alignItem = [
    classes.center, classes.center,
    classes.center,
    classes.right, classes.right, classes.center,
    classes.center, classes.center, classes.center, classes.center,
  ];
  const cboPerPage = [
    { id: 10, name: "element.show_10_record" },
    { id: 20, name: "element.show_20_record" },
    { id: 100, name: "element.show_100_record" },
  ];

  const app = useSelector((state) => state.appState);
  const { id } = useParams();
  const [pageTotal, setPageTotal] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [record, setRecord] = useState([]);
  const [attr, setAttr] = useState(initAttr);
  const [find, setFind] = useState(initFind);
  const [header, setHeader] = useState(initHeader);
  const [alert, setAlert] = useState(null);
  const [notify, setNotify] = useState(null);
  const [tab, setTab] = useState(0);
  const [loading, setLoading] = useState(false);
  const [cboProvince, setCboProvince] = useState([]);
  const [cboType, setCboType] = useState([]);
  const [cboPrice, setCboPrice] = useState([]);
  const [credit, setCredit] = useState([]);
  const [promotion, setPromotion] = useState([]);
  const [list, setList] = useState([]);
  const [field, setField] = useState(initField);
  const [modalCreditAdd, setModalCreditAdd] = useState(false);
  const [creditType, setCreditType] = useState("add");

  useEffect(() => {
    i18n.changeLanguage(app.lang);
    init();
  }, [id]);

  const init = () => {
    PostData(mod, "init", {
      token: app.token,
      lang: app.lang,
    }).then((result) => {
      if (result.status === "OK") {
        if (id === undefined) {
          view(find);
        } else if (id === "add") {
          setCboType(result.type);
          setCboProvince(result.province);
          setCboPrice(result.price);
          setAttr(initAttr);
        } else {
          setCboType(result.type);
          setCboProvince(result.province);
          setCboPrice(result.price);
          setTab(0);
          open();
        }
      } else {
        Func.exitApp();
      }
    });
  };

  const changeTab = (event, value) => {
    setTab(value);
  };

  const inputChange = (e) => {
    setAttr({ ...attr, [e.target.id]: e.target.value });
  };

  const checkChange = (e) => {
    setAttr({ ...attr, [e.target.name]: e.target.checked ? "Y" : "N" });
  };

  const selectChange = (e) => {
    setAttr({ ...attr, [e.target.name]: e.target.value });
  };

  const view = (data) => {
    setLoading(true);
    PostData(mod, "view", {
      token: app.token,
      lang: app.lang,
      search: data.search,
      page: data.page,
      per_page: data.perPage,
      orderby: data.order_by,
      asc: data.order_sort,
      status: data.status,
    }).then((result) => {
      if (result.status === "OK") {
        setRecord([]);

        result.data.map((item, i) => {
          setRecord((record) => [
            ...record,
            [
              item.code,
              img(item.image),
              btnOpen(item),
              item.name,
              item.company_name,
              item.type_name,
              item.price_name,
              item.balance,
              item.credit,
              item.credit_day,
              Func.checkDisplay(item.gen_receipt),
              Func.checkDisplay(item.shipping),
              Func.checkDisplay(item.enable),
              btn(item),
            ],
          ]);
        });

        setPageTotal(result.total_pages);
        setPageNo(result.page);
      }
      setLoading(false);
    });
  };

  const btnOpen = (item) => {
    return (
      <NavLink to={`/admin/${mod}/${item.code}`}>
        <Button color="primary" simple>
          {item.id}
        </Button>
      </NavLink>
    );
  };

  const img = (filename) => {
    return <img src={filename} width="30" />;
  };

  const open = () => {
    setLoading(true);
    setAttr(initAttr);
    setList([]);
    setCredit([]);
    setPromotion([]);

    PostData(mod, "open", {
      token: app.token,
      lang: app.lang,
      code: id,
    }).then((result) => {
      if (result.status === "OK") {
        setAttr(result.data);

        result.credit.map((item, i) => {
          setCredit((credit) => [
            ...credit,
            [
              i + 1,
              item.credit_type,
              Func.numberDisplay(item.credit),
              Func.numberDisplay(item.credit_before),
              Func.numberDisplay(item.credit_after),
              item.date_create,
              item.remark,
            ],
          ]);
        });

        result.list.map((item, i) => {
          setList((list) => [
            ...list,
            [
              i + 1,
              <img src={item.filepic} width="30" />,
              item.product_id,
              item.product_name,
              Func.numberDisplay(item.quantity, 0),
              item.unit_name,
              Func.numberDisplay(item.price),
            ],
          ]);
        });

        result.promotion.map((item, i) => {
          setPromotion((promotion) => [
            ...promotion,
            {
              title:
                `${i + 1}. ` +
                t(`${mod}.quantity_min`) +
                ` : ` +
                Func.numberDisplay(item.data.quantity, 0) +
                ` ${item.data.unit_name}`,
              content: tablePromotion(item.list),
            },
          ]);
        });

        setLoading(false);
      }
    });
  };

  const del = (item) => {
    setAlert(
      <SweetAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title={t("alert.confirm_delete_title")}
        onConfirm={() => {
          setAlert(null);
          setLoading(true);

          PostData(mod, "delete", {
            token: app.token,
            lang: app.lang,
            code: item.code,
          }).then((result) => {
            setLoading(false);

            if (result.status === "OK") {
              view(find);
              showNotify(t("alert.deletecomplete"), "success");
            } else {
              showNotify(t("alert.deleteerror"), "danger");
            }
          });
        }}
        onCancel={() => setAlert(null)}
        confirmBtnCssClass={classes.button + " " + classes.success}
        cancelBtnCssClass={classes.button + " " + classes.danger}
        confirmBtnText={t("alert.ok")}
        cancelBtnText={t("alert.cancel")}
        showCancel
      >
        {t("alert.confirm_delete_msg")} #{item.code}
      </SweetAlert>
    );
  };

  const uploadImage = (filedata) => {
    setAlert(
      <SweetAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title={t("alert.confirm_edit_title")}
        onConfirm={() => {
          setAlert(null);
          setLoading(true);

          PostData(mod, "upload", {
            code: attr.code,
            token: app.token,
            lang: app.lang,
            filedata: filedata,
          }).then((result) => {
            setLoading(false);

            if (result.status === "OK") {
              open();
              showNotify(t("alert.editcomplete"), "success");
            } else {
              showNotify(t("alert.editerror"), "danger");
            }
          });
        }}
        onCancel={() => {
          setAlert(null);
        }}
        confirmBtnCssClass={classes.button + " " + classes.success}
        cancelBtnCssClass={classes.button + " " + classes.danger}
        confirmBtnText={t("alert.ok")}
        cancelBtnText={t("alert.cancel")}
        showCancel
      >
        {t("upload.upload")}
      </SweetAlert>
    );
  };

  const editCredit = () => {
    setAlert(
      <SweetAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title={t("alert.confirm_edit_title")}
        onConfirm={() => {
          setAlert(null);
          setLoading(true);

          PostData(mod, "editcredit", {
            code: attr.code,
            data: {
              credit_day: attr.credit_day,
            },
          }).then((result) => {
            setLoading(false);

            if (result.status === "OK") {
              open();
              showNotify(t("alert.editcomplete"), "success");
            } else {
              showNotify(t("alert.editerror"), "danger");
            }
          });
        }}
        onCancel={() => setAlert(null)}
        confirmBtnCssClass={classes.button + " " + classes.success}
        cancelBtnCssClass={classes.button + " " + classes.danger}
        confirmBtnText={t("alert.ok")}
        cancelBtnText={t("alert.cancel")}
        showCancel
      >
        {t("alert.confirm_edit_msg")} #{attr.code}
      </SweetAlert>
    );
  };

  const checkEmpty = () => {
    let result = true;

    if (!Func.verifyLength(attr.id, 1)) {
      result = false;
    } else if (!Func.verifyLength(attr.name, 1)) {
      result = false;
    }

    return result;
  };

  const add = () => {
    if (!checkEmpty()) {
      showNotify(t("alert.pleaseinsert"), "danger");
    } else {
      setAlert(
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title={t("alert.confirm_add_title")}
          onConfirm={() => {
            setAlert(null);
            setLoading(true);

            PostData(mod, "add", {
              data: {
                id: attr.id,
                name: attr.name,
                company_name: attr.company_name,
                company_id: attr.company_id,
                tel: attr.tel,
                lineid: attr.lineid,
                idcard: attr.idcard,
                email: attr.email,
                address: attr.address,
                district: attr.district,
                city: attr.city,
                zipcode: attr.zipcode,
                promotion_code: attr.promotion_code,
                type_code: attr.type_code,
                province_code: attr.province_code,
                shipping: attr.shipping,
                gen_receipt: attr.gen_receipt,
                enable: attr.enable,
              },
            }).then((result) => {
              setLoading(false);

              if (result.status === "OK") {
                showNotify(t("alert.addcomplete"), "success");
                window.location.assign(`/admin/${mod}`);
              } else {
                showNotify(t("alert.adderror"), "danger");
              }
            });
          }}
          onCancel={() => setAlert(null)}
          confirmBtnCssClass={classes.button + " " + classes.success}
          cancelBtnCssClass={classes.button + " " + classes.danger}
          confirmBtnText={t("alert.ok")}
          cancelBtnText={t("alert.cancel")}
          showCancel
        >
          {t("alert.confirm_add_msg")}
        </SweetAlert>
      );
    }
  };

  const edit = () => {
    if (!checkEmpty()) {
      showNotify(t("alert.pleaseinsert"), "danger");
    } else {
      setAlert(
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title={t("alert.confirm_edit_title")}
          onConfirm={() => {
            setAlert(null);
            setLoading(true);

            PostData(mod, "edit", {
              code: attr.code,
              data: {
                id: attr.id,
                name: attr.name,
                company_name: attr.company_name,
                company_id: attr.company_id,
                tel: attr.tel,
                lineid: attr.lineid,
                idcard: attr.idcard,
                email: attr.email,
                address: attr.address,
                district: attr.district,
                city: attr.city,
                zipcode: attr.zipcode,
                promotion_code: attr.promotion_code,
                type_code: attr.type_code,
                province_code: attr.province_code,
                shipping: attr.shipping,
                gen_receipt: attr.gen_receipt,
                enable: attr.enable,
              },
            }).then((result) => {
              setLoading(false);

              if (result.status === "OK") {
                open();
                showNotify(t("alert.editcomplete"), "success");
              } else {
                showNotify(t("alert.editerror"), "danger");
              }
            });
          }}
          onCancel={() => setAlert(null)}
          confirmBtnCssClass={classes.button + " " + classes.success}
          cancelBtnCssClass={classes.button + " " + classes.danger}
          confirmBtnText={t("alert.ok")}
          cancelBtnText={t("alert.cancel")}
          showCancel
        >
          {t("alert.confirm_edit_msg")} #{attr.code}
        </SweetAlert>
      );
    }
  };

  const showNotify = (msg, color) => {
    setNotify(
      <Snackbar
        place="tr"
        color={color}
        icon={AlertIcon}
        message={msg}
        open={true}
        closeNotification={() => setNotify(null)}
        close
      />
    );

    setTimeout(function () {
      setNotify(null);
    }, 3000);
  };

  const addCredit = () => {
    if (!Func.verifyLength(field.credit, 1)) {
      showNotify(t("alert.pleaseinsert"), "danger");
    } else {
      setAlert(
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title={t("alert.confirm_add_title")}
          onConfirm={() => {
            setAlert(null);
            setModalCreditAdd(false);
            setLoading(true);

            PostData(mod, "addcredit", {
              token: app.token,
              lang: app.lang,
              credit: field.credit,
              code: id,
              data: {
                credit_type: "DEPOSIT",
                member_code: id,
                credit: field.credit,
                remark: field.remark,
              },
            }).then((result) => {
              setAlert(null);
              if (result.status === "OK") {
                open();
                showNotify(t("alert.addcomplete"), "success");
              } else {
                showNotify(t("alert.adderror"), "danger");
              }
            });
          }}
          onCancel={() => setAlert(null)}
          confirmBtnCssClass={classes.button + " " + classes.success}
          cancelBtnCssClass={classes.button + " " + classes.danger}
          confirmBtnText={t("alert.ok")}
          cancelBtnText={t("alert.cancel")}
          showCancel
        >
          {t("alert.confirm_add_msg")}
        </SweetAlert>
      );
    }
  };

  const removeCredit = () => {
    if (!Func.verifyLength(field.credit, 1)) {
      showNotify(t("alert.pleaseinsert"), "danger");
    } else {
      setAlert(
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title={t("alert.confirm_withdraw_credit")}
          onConfirm={() => {
            setAlert(null);
            setModalCreditAdd(false);
            setLoading(true);

            PostData(mod, "removecredit", {
              token: app.token,
              lang: app.lang,
              credit: field.credit,
              code: id,
              data: {
                credit_type: "WITHDRAW",
                member_code: id,
                credit: field.credit,
                remark: field.remark,
              },
            }).then((result) => {
              setAlert(null);
              if (result.status === "OK") {
                open();
                showNotify(t("alert.addcomplete"), "success");
              } else {
                showNotify(t("alert.adderror"), "danger");
              }
            });
          }}
          onCancel={() => setAlert(null)}
          confirmBtnCssClass={classes.button + " " + classes.success}
          cancelBtnCssClass={classes.button + " " + classes.danger}
          confirmBtnText={t("alert.ok")}
          cancelBtnText={t("alert.cancel")}
          showCancel
        >
          {t("alert.confirm_withdraw_credit_title")}
        </SweetAlert>
      );
    }
  };

  const btn = (item) => {
    return (
      <>
        <NavLink to={`/admin/${mod}/${item.code}`}>
          <Button
            round
            color="success"
            className={classes.actionButton + " " + classes.actionButtonRound}
          >
            <EditIcon className={classes.icon} />
          </Button>
        </NavLink>
        <Button
          round
          color="danger"
          className={classes.actionButton + " " + classes.actionButtonRound}
          onClick={() => del(item)}
        >
          <DeleteIcon className={classes.icon} />
        </Button>
      </>
    );
  };

  const renderHeader = (data) => {
    let icon = <i className="fas fa-sort"></i>;
    if (data.order === "desc") {
      icon = <i className="fad fa-sort-up"></i>;
    } else if (data.order === "asc") {
      icon = <i className="fad fa-sort-down"></i>;
    } else {
      icon = <i className="fad fa-sort"></i>;
    }

    if (data.sort === undefined || data.sort)
      return (
        <div
          onClick={() => {
            let tmp = [];
            header.map((item, i) => {
              if (data.code === item.code) {
                const ordersort = item.order === "asc" ? "desc" : "asc";
                view({ ...find, order_sort: ordersort, order_by: data.code });
                setFind({
                  ...find,
                  order_sort: ordersort,
                  order_by: data.code,
                });
                tmp[i] = {
                  code: item.code,
                  name: item.name,
                  order: ordersort,
                  sort: item.sort,
                };
              } else {
                tmp[i] = {
                  code: item.code,
                  name: item.name,
                  order: "",
                  sort: item.sort,
                };
              }
            });

            setHeader(tmp);
          }}
          style={{ cursor: "pointer" }}
        >
          {t(data.name)} {icon}
        </div>
      );
    else return <div>{t(data.name)}</div>;
  };

  const renderViewList = () => {
    return (
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="primary" icon>
              <CardIcon color="primary">
                <AssignmentIcon />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>{t("element.viewlist")}</h4>
            </CardHeader>
            <CardBody>
              <GridContainer className="viewlist">
                <GridItem xs={12} sm={6} md={6}>
                  <TextField
                    id="search"
                    fullWidth
                    InputProps={{
                      onChange: (e) => {
                        view({ ...find, search: e.target.value, page: 1 });
                        setFind({ ...find, search: e.target.value, page: 1 });
                      },
                      value: find.search,
                      startAdornment: (
                        <InputAdornment position="start">
                          {t("element.search")} :
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                      autoComplete: "off",
                    }}
                  />
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12}>
                  <Table
                    striped
                    hover
                    tableHead={[
                      renderHeader(header[0]),
                      renderHeader(header[1]),
                      renderHeader(header[2]),
                      renderHeader(header[3]),
                      renderHeader(header[4]),
                      renderHeader(header[5]),
                      renderHeader(header[6]),
                      renderHeader(header[7]),
                      renderHeader(header[8]),
                      renderHeader(header[9]),
                      renderHeader(header[10]),
                      renderHeader(header[11]),
                      renderHeader(header[12]),
                      <NavLink to={`/admin/${mod}/add`}>
                        <Button
                          round
                          color="primary"
                          className={classes.actionButton}
                        >
                          {t(`element.add`)}
                          <AddIcon />
                        </Button>
                      </NavLink>,
                    ]}
                    tableData={record}
                    customHeadClassesForCells={alignValue}
                    customHeadCellClasses={alignItem}
                    customClassesForCells={alignValue}
                    customCellClasses={alignItem}
                    coloredColls={[]}
                    colorsColls={[]}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={6} md={4} lg={3}>
                  <FormControl fullWidth className={classes.selectFormControl}>
                    <InputLabel className={classes.selectLabel}></InputLabel>
                    <Select
                      value={find.perPage}
                      onChange={(e) => {
                        view({
                          ...find,
                          page: 1,
                          perPage: e.target.value,
                          page: 1,
                        });
                        setFind({
                          ...find,
                          page: 1,
                          perPage: e.target.value,
                          page: 1,
                        });
                      }}
                    >
                      {cboPerPage &&
                        cboPerPage.map((item) => (
                          <MenuItem
                            key={item.id}
                            classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected,
                            }}
                            value={item.id}
                          >
                            {t(item.name)}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </GridItem>
                <GridItem
                  xs={12}
                  sm={6}
                  md={8}
                  lg={9}
                  className={classes.right}
                >
                  <Pagination
                    style={{ float: "right", marginTop: "20px" }}
                    count={pageTotal}
                    showFirstButton
                    showLastButton
                    page={pageNo}
                    onChange={(e, p) => {
                      view({ ...find, page: p });
                      setFind({ ...find, page: p });
                    }}
                  />
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  };

  const renderAdd = () => {
    return (
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardBody>
              <GridContainer>
                <GridItem xs={6}>
                  <h4>{t("element.adddata")}</h4>
                </GridItem>
                <GridItem xs={6} className={classes.right}>
                  <NavLink to={`/admin/${mod}`}>
                    <Button color="warning">
                      <ArrowBackIcon /> {t("element.back")}
                    </Button>
                  </NavLink>
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12}>
          <CustomTabs
            headerColor="primary"
            value={tab}
            changeValue={changeTab}
            tabs={[
              {
                tabName: t("element.info"),
                tabIcon: DescriptionIcon,
                tabContent: (
                  <div>
                    {renderInfo()}
                    <GridContainer>
                      <GridItem xs={12} className={classes.right}>
                        <Button color="success" onClick={add}>
                          <SaveIcon /> {t("element.save")}
                        </Button>
                      </GridItem>
                    </GridContainer>
                  </div>
                ),
              },
            ]}
          />
        </GridItem>
        <GridItem xs={12}>{renderDetail()}</GridItem>
      </GridContainer>
    );
  };

  const renderEdit = () => {
    return (
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardBody>
              <GridContainer>
                <GridItem xs={6}>
                  <h4>{attr.name}</h4>
                </GridItem>
                <GridItem xs={6} className={classes.right}>
                  <NavLink to={`/admin/${mod}`}>
                    <Button color="warning">
                      <ArrowBackIcon /> {t("element.back")}
                    </Button>
                  </NavLink>
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12}>
          <CustomTabs
            headerColor="primary"
            value={tab}
            changeValue={changeTab}
            tabs={[
              {
                tabName: t("element.info"),
                tabIcon: DescriptionIcon,
                tabContent: (
                  <div>
                    {renderInfo()}
                    <GridContainer>
                      <GridItem xs={12} className={classes.right}>
                        <Button color="success" onClick={edit}>
                          <SaveIcon /> {t("element.save")}
                        </Button>
                      </GridItem>
                    </GridContainer>
                  </div>
                ),
              },
              {
                tabName: t("upload.avatar"),
                tabIcon: DescriptionIcon,
                tabContent: renderImage(),
              },
              {
                tabName: t(`${mod}.credit`),
                tabIcon: ListAltIcon,
                tabContent: renderCredit(),
              },
              {
                tabName: t(`${mod}.promotiongroup`),
                tabIcon: ListAltIcon,
                tabContent: renderPromotionGroup(),
              },
              {
                tabName: t("field.freight"),
                tabIcon: ListAltIcon,
                tabContent: <MemberTransfer />,
              },
              {
                tabName: `Wallet`,
                tabIcon: ListAltIcon,
                tabContent: <MemberWallet />,
              },
            ]}
          />
        </GridItem>
        <GridItem xs={12}>{renderDetail()}</GridItem>
      </GridContainer>
    );
  };

  const renderImage = () => {
    return (
      <GridContainer>
        <GridItem xs={12} sm={6} md={4}>
          <Card>
            <CardBody>
              <div
                className="fileinput text-center"
                style={{ display: "block" }}
              >
                <div
                  className={"thumbnail"}
                  style={{ maxWidth: "100%", textAlign: "center" }}
                >
                  <img src={attr.image} />
                </div>
              </div>
              <UploadImage uploadData={uploadImage} />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  };

  const renderPromotionGroup = () => {
    return (
      <GridContainer>
        <GridItem xs={12}>
          <Accordion active={0} collapses={promotion} />
        </GridItem>
        {attr.promotion_code > 0 ? (
          <GridItem xs={12} className={classes.right}>
            <Button
              color="success"
              className={classes.colorWhite}
              href={`/admin/promotion/${attr.promotion_code}`}
            >
              <EditIcon /> {t(`${mod}.editprice`)}
            </Button>
          </GridItem>
        ) : null}
      </GridContainer>
    );
  };

  const renderCredit = () => {
    return (
      <GridContainer>
        <GridItem xs={12}>
          <Table
            striped
            hover
            tableData={[
              [
                <h4>{t(`${mod}.credit_day`)} :</h4>,
                <Input
                  id="credit_day"
                  placeholder="0"
                  inputProps={{
                    "aria-label": "credit_day",
                    value: attr.credit_day,
                  }}
                  classes={{
                    input: classes.right,
                  }}
                  color="primary"
                  fullWidth={false}
                  onChange={inputChange}
                />,
                <Button round color="success" size="sm" onClick={editCredit}>
                  <SaveIcon className={classes.icon} /> {t("element.save")}
                </Button>,
              ],
              [
                <h4>{t(`${mod}.credit`)} :</h4>,
                <h4>
                  {Func.numberDisplay(attr.credit)} /{" "}
                  {Func.numberDisplay(attr.credit_total)}
                </h4>,
                <>
                  <Button
                    round
                    color="info"
                    size="sm"
                    onClick={() => {
                      setField(initField);
                      setCreditType("add");
                      setModalCreditAdd(true);
                    }}
                  >
                    <AddIcon className={classes.icon} /> {t("element.add")}
                  </Button>
                  <Button
                    round
                    color="danger"
                    size="sm"
                    onClick={() => {
                      setField(initField);
                      setCreditType("sub");
                      setModalCreditAdd(true);
                    }}
                  >
                    <RemoveCircleIcon className={classes.icon} />
                    {t("element.sub")}
                  </Button>
                </>,
              ],
            ]}
            customClassesForCells={[0, 1]}
            customCellClasses={[classes.right, classes.center]}
            coloredColls={[1]}
            colorsColls={["primary"]}
          />
        </GridItem>
        <GridItem xs={12}>
          <Table
            striped
            hover
            tableHead={[
              t(`${mod}.num`),
              t(`${mod}.credit_type`),
              t(`${mod}.credit`),
              t(`${mod}.credit_before`),
              t(`${mod}.credit_after`),
              t(`${mod}.date`),
              t(`${mod}.remark`),
            ]}
            tableData={credit}
            customHeadClassesForCells={[0, 1, 2, 3, 4, 5]}
            customHeadCellClasses={[
              classes.center,
              classes.center,
              classes.right,
              classes.right,
              classes.right,
              classes.center,
            ]}
            customClassesForCells={[0, 1, 2, 3, 4, 5]}
            customCellClasses={[
              classes.center,
              classes.center,
              classes.right,
              classes.right,
              classes.right,
              classes.center,
            ]}
            coloredColls={[2, 3, 4]}
            colorsColls={["primary", "danger", "success"]}
          />
        </GridItem>
      </GridContainer>
    );
  };

  const tablePromotion = (list) => {
    return (
      <GridContainer>
        <GridItem xs={12}>
          <Table
            striped
            hover
            tableHead={[
              t(`${mod}.num`),
              t(`${mod}.image`),
              t(`${mod}.product_id`),
              t(`${mod}.product_name`),
              t(`${mod}.price`),
            ]}
            tableData={list.map((item, i) => [
              i + 1,
              <img src={item.filepic} width="30" />,
              item.product_id,
              item.product_name,
              Func.numberDisplay(item.price),
            ])}
            customHeadClassesForCells={[0, 1, 4]}
            customHeadCellClasses={[
              classes.center,
              classes.center,
              classes.right,
            ]}
            customClassesForCells={[0, 1, 4]}
            customCellClasses={[classes.center, classes.center, classes.right]}
            coloredColls={[4, 6]}
            colorsColls={["success", "primary"]}
          />
        </GridItem>
        <GridItem
          xs={12}
          className={classes.center}
          style={{ marginTop: "20px" }}
        ></GridItem>
      </GridContainer>
    );
  };

  const renderInfo = () => {
    return (
      <form autoComplete="off">
        <GridContainer>
          <GridItem xs={12} sm={6} md={4}>
            <CustomInput
              labelText={
                <div>
                  {t(`${mod}.id`)}
                  <span className={classes.colorDanger}> *</span>
                </div>
              }
              id="id"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                onChange: inputChange,
                value: attr.id,
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={6} md={4}>
            <CustomInput
              labelText={
                <div>
                  {t(`${mod}.name`)}
                  <span className={classes.colorDanger}> *</span>
                </div>
              }
              id="name"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                onChange: inputChange,
                value: attr.name,
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={6} md={4}>
            <CustomInput
              labelText={t(`${mod}.company_name`)}
              id="company_name"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                onChange: inputChange,
                value: attr.company_name,
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={6} md={4}>
            <CustomInput
              labelText={<div>{t(`${mod}.company_id`)}</div>}
              id="company_id"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                onChange: inputChange,
                value: attr.company_id,
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={6} md={4}>
            <CustomInput
              labelText={t(`${mod}.email`)}
              id="email"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                onChange: inputChange,
                value: attr.email,
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={6} md={4}>
            <CustomInput
              labelText={t(`${mod}.tel`)}
              id="tel"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                onChange: inputChange,
                value: attr.tel,
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={6} md={4}>
            <CustomInput
              labelText={t(`${mod}.lineid`)}
              id="lineid"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                onChange: inputChange,
                value: attr.lineid,
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={6} md={4}>
            <FormControl fullWidth className={classes.selectFormControl}>
              <InputLabel htmlFor="type_code" className={classes.labelSelect}>
                {t(`${mod}.type`)}
              </InputLabel>
              <Select
                MenuProps={{
                  className: classes.selectMenu,
                }}
                classes={{
                  select: classes.select,
                }}
                value={attr.type_code}
                inputProps={{
                  name: "type_code",
                }}
                onChange={selectChange}
              >
                <MenuItem
                  disabled
                  classes={{
                    root: classes.selectMenuItem,
                  }}
                >
                  {t("element.pleaseselect")}
                </MenuItem>
                {cboType &&
                  cboType.map((item) => (
                    <MenuItem
                      key={item.code}
                      classes={{
                        root: classes.selectMenuItem,
                        selected: classes.selectMenuItemSelected,
                      }}
                      value={item.code}
                    >
                      {item.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={6} md={4}>
            <FormControl fullWidth className={classes.selectFormControl}>
              <InputLabel
                htmlFor="promotion_code"
                className={classes.labelSelect}
              >
                {t(`${mod}.promotion`)}
              </InputLabel>
              <Select
                MenuProps={{
                  className: classes.selectMenu,
                }}
                classes={{
                  select: classes.select,
                }}
                value={attr.promotion_code}
                inputProps={{
                  name: "promotion_code",
                }}
                onChange={selectChange}
              >
                <MenuItem
                  disabled
                  classes={{
                    root: classes.selectMenuItem,
                  }}
                >
                  {t("element.pleaseselect")}
                </MenuItem>
                {cboPrice &&
                  cboPrice.map((item) => (
                    <MenuItem
                      key={item.code}
                      classes={{
                        root: classes.selectMenuItem,
                        selected: classes.selectMenuItemSelected,
                      }}
                      value={item.code}
                    >
                      {item.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={6} md={8}>
            <CustomInput
              labelText={t(`${mod}.address`)}
              id="address"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                onChange: inputChange,
                value: attr.address,
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={6} md={4}>
            <CustomInput
              labelText={t(`${mod}.district`)}
              id="district"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                onChange: inputChange,
                value: attr.district,
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={6} md={4}>
            <CustomInput
              labelText={t(`${mod}.city`)}
              id="city"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                onChange: inputChange,
                value: attr.city,
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={6} md={4}>
            <FormControl fullWidth className={classes.selectFormControl}>
              <InputLabel
                htmlFor="province_code"
                className={classes.labelSelect}
              >
                {t(`${mod}.province`)}
              </InputLabel>
              <Select
                MenuProps={{
                  className: classes.selectMenu,
                }}
                classes={{
                  select: classes.select,
                }}
                value={attr.province_code}
                inputProps={{
                  name: "province_code",
                }}
                onChange={selectChange}
              >
                <MenuItem
                  disabled
                  classes={{
                    root: classes.selectMenuItem,
                  }}
                >
                  {t("element.pleaseselect")}
                </MenuItem>
                {cboProvince &&
                  cboProvince.map((item) => (
                    <MenuItem
                      key={item.code}
                      classes={{
                        root: classes.selectMenuItem,
                        selected: classes.selectMenuItemSelected,
                      }}
                      value={item.code}
                    >
                      {item.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={6} md={4}>
            <CustomInput
              labelText={t(`${mod}.zipcode`)}
              id="zipcode"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                onChange: inputChange,
                value: attr.zipcode,
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={6} md={4}>
            <div className={classes.checkboxAndRadio}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={attr.gen_receipt === "Y"}
                    name="gen_receipt"
                    tabIndex={-1}
                    onChange={checkChange}
                    checkedIcon={<Check className={classes.checkedIcon} />}
                    icon={<Check className={classes.uncheckedIcon} />}
                    classes={{
                      checked: classes.checked,
                      root: classes.checkRoot,
                    }}
                  />
                }
                classes={{
                  label: classes.label,
                  root: classes.labelRoot,
                }}
                label={t("field.vat_system")}
              />
            </div>
          </GridItem>
          <GridItem xs={12} sm={6} md={4}>
            <div className={classes.checkboxAndRadio}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={attr.shipping === "Y"}
                    name="shipping"
                    tabIndex={-1}
                    onChange={checkChange}
                    checkedIcon={<Check className={classes.checkedIcon} />}
                    icon={<Check className={classes.uncheckedIcon} />}
                    classes={{
                      checked: classes.checked,
                      root: classes.checkRoot,
                    }}
                  />
                }
                classes={{
                  label: classes.label,
                  root: classes.labelRoot,
                }}
                label={t(`${mod}.shipping`)}
              />
            </div>
          </GridItem>
          <GridItem xs={12} sm={6} md={4}>
            <div className={classes.checkboxAndRadio}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={attr.enable === "Y"}
                    name="enable"
                    tabIndex={-1}
                    onChange={checkChange}
                    checkedIcon={<Check className={classes.checkedIcon} />}
                    icon={<Check className={classes.uncheckedIcon} />}
                    classes={{
                      checked: classes.checked,
                      root: classes.checkRoot,
                    }}
                  />
                }
                classes={{
                  label: classes.label,
                  root: classes.labelRoot,
                }}
                label={t("attr.enable")}
              />
            </div>
          </GridItem>
        </GridContainer>
      </form>
    );
  };

  const renderCreditAdd = () => {
    return (
      <Dialog
        classes={{
          root: classes.center + " " + classes.modalRoot,
          paper: classes.modal,
        }}
        open={modalCreditAdd}
        maxWidth={"sm"}
        fullWidth
        keepMounted
        onClose={() => setModalCreditAdd(false)}
        aria-labelledby="modal-slide-title"
        aria-describedby="modal-slide-description"
      >
        <DialogTitle
          id="modal-edit-title"
          disableTypography
          className={classes.modalHeader}
        >
          <Button
            justIcon
            className={classes.modalCloseButton}
            key="close"
            aria-label="Close"
            color="transparent"
            onClick={() => setModalCreditAdd(false)}
          >
            <CloseIcon className={classes.modalClose} />
          </Button>
          <h4 className={classes.modalTitle}>
            {t(`${mod}.credit_${creditType}`)}
          </h4>
        </DialogTitle>
        <DialogContent id="modal-edit" className={classes.modalBody}>
          <form autoComplete="off">
            <GridContainer>
              <GridItem xs={12}>
                <CustomInput
                  labelText={t(`${mod}.credit`)}
                  id="txt_credit"
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    value: field.credit,
                    onChange: (e) => {
                      setField({ ...field, credit: e.target.value });
                    },
                  }}
                />
              </GridItem>
              <GridItem xs={12}>
                <CustomInput
                  labelText={t(`${mod}.remark`)}
                  id="txt_remark"
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    value: field.remark,
                    onChange: (e) => {
                      setField({ ...field, remark: e.target.value });
                    },
                  }}
                />
              </GridItem>
            </GridContainer>
          </form>
        </DialogContent>
        <DialogActions className={classes.modalFooter}>
          {creditType === "add" ? (
            <Button onClick={addCredit} color="success">
              <SaveIcon /> {t(`element.save`)}
            </Button>
          ) : (
            <Button onClick={removeCredit} color="success">
              <SaveIcon /> {t(`element.save`)}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    );
  };

  const renderDetail = () => {
    return (
      <GridContainer>
        <GridItem xs={12} sm={6} md={3} lg={3}>
          <Card>
            <CardHeader icon>
              <CardIcon color="warning">
                <PersonIcon />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>{t("attr.user_create")}</h4>
            </CardHeader>
            <CardBody>
              <p className={classes.statusCenter}>{attr.user_create}</p>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3} lg={3}>
          <Card>
            <CardHeader icon>
              <CardIcon color="warning">
                <PersonOutlineOutlinedIcon />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>{t("attr.date_create")}</h4>
            </CardHeader>
            <CardBody>
              <p className={classes.statusCenter}>{attr.date_create}</p>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3} lg={3}>
          <Card>
            <CardHeader icon>
              <CardIcon color="warning">
                <DateRangeIcon />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>{t("attr.user_update")}</h4>
            </CardHeader>
            <CardBody>
              <p className={classes.statusCenter}>{attr.user_update}</p>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3} lg={3}>
          <Card>
            <CardHeader icon>
              <CardIcon color="warning">
                <DateRangeOutlinedIcon />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>{t("attr.date_update")}</h4>
            </CardHeader>
            <CardBody>
              <p className={classes.statusCenter}>{attr.date_update}</p>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  };

  const renderLoading = () => {
    return (
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  };

  const renderPage = () => {
    if (id === undefined) {
      return renderViewList();
    } else if (id === "add") {
      return renderAdd();
    } else {
      return renderEdit();
    }
  };

  /* ========== ZONE Render ========== */
  return (
    <div>
      {renderPage()}
      {renderLoading()}
      {renderCreditAdd()}
      {alert}
      {notify}
    </div>
  );
}

export default withNamespaces()(MemberType);
